import { useScrollReveal } from '@/hooks/useScrollReveal';

const required = [
  'プロジェクト管理やチームマネジメントの経験がある方',
  '新しいことへの好奇心が強く、AIや映像分野に関心がある方',
  '高知で働くことに前向きな方（移住支援あり）',
  '自走できる方、曖昧な状況でも楽しめる方',
];

const welcome = [
  'アニメ・映像・エンタメ業界での経験がある方',
  '地方移住・地方での起業経験がある方',
  '行政や外部パートナーとの折衝経験がある方',
  'AIツールの活用経験がある方',
];

export default function IdealCandidateSection() {
  const { ref: headRef, isVisible: headVisible } = useScrollReveal<HTMLDivElement>();
  const { ref: bodyRef, isVisible: bodyVisible } = useScrollReveal<HTMLDivElement>();
  const { ref: noteRef, isVisible: noteVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <section id="candidate" className="bg-cream py-24 md:py-36">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        {/* Section label */}
        <div className="flex items-center gap-4 mb-16">
          <span className="font-sans text-terracotta text-[11px] tracking-[0.4em] uppercase">04</span>
          <div className="flex-1 h-px bg-warm-border" />
          <span className="font-sans text-warm-muted text-[11px] tracking-[0.3em]">Ideal Candidate</span>
        </div>

        <div
          ref={headRef}
          className={`mb-16 transition-all duration-900 ${headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <h2 className="font-serif text-charcoal text-2xl md:text-3xl lg:text-4xl leading-loose">
            こんな人と、<br />一緒に作っていきたい。
          </h2>
        </div>

        <div
          ref={bodyRef}
          className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 transition-all duration-1000 ${bodyVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          {/* Required */}
          <div>
            <p className="font-sans text-terracotta text-xs tracking-[0.3em] uppercase mb-8">Must</p>
            <ul className="space-y-6">
              {required.map((item) => (
                <li key={item} className="flex items-start gap-4">
                  <span className="mt-1.5 flex-shrink-0 w-5 h-5 flex items-center justify-center">
                    <i className="ri-checkbox-circle-line text-terracotta text-lg" />
                  </span>
                  <p className="font-sans text-charcoal text-sm md:text-base leading-relaxed">{item}</p>
                </li>
              ))}
            </ul>
          </div>

          {/* Welcome */}
          <div>
            <p className="font-sans text-warm-muted text-xs tracking-[0.3em] uppercase mb-8">Welcome</p>
            <ul className="space-y-6">
              {welcome.map((item) => (
                <li key={item} className="flex items-start gap-4">
                  <span className="mt-1.5 flex-shrink-0 w-5 h-5 flex items-center justify-center">
                    <i className="ri-add-circle-line text-warm-muted text-lg" />
                  </span>
                  <p className="font-sans text-warm-muted text-sm md:text-base leading-relaxed">{item}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Note */}
        <div
          ref={noteRef}
          className={`mt-16 pt-10 border-t border-warm-border transition-all duration-1000 delay-300 ${noteVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
        >
          <div className="bg-parchment rounded-lg p-8 md:p-10 max-w-3xl">
            <p className="font-sans text-warm-muted text-sm leading-loose">
              <span className="text-terracotta font-medium">アニメ経験は必須ではありません。</span>
              AIアニメ制作は、これまでのアニメ制作とは異なる新しい領域です。
              経験よりも、好奇心とマネジメント力を重視します。
              ゼロから一緒に学びながら、新しいスタンダードをつくっていける方を求めています。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
